export const PACKAGE_NAME = 'jiraSoftwareAutoEnableDes';
export const PACKAGE_TEAM_NAME = 'jlove-makkuro';
